import React from 'react';
import PropTypes from 'prop-types';
import { ProviderDate } from '@bagonboard/ui-kit';

import { Text } from './style';

const Created = ({
  value,
}) => (
  <Text>{ProviderDate.verbose(value, 'DD/MM/YYYY', 'en')}</Text>
);

Created.propTypes = {
  value: PropTypes.string,
};

Created.defaultProps = {
  value: '',
};

export default Created;
